// Typelizer digest 9bf5c608edb27ba0b94ebb965a8803ca
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /c/:company_id/ledger/payments/:payment_id/questions */
  create: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/payments/:payment_id/questions', params, options),
    method: 'post',
  }),
}
